import React from 'react';
import cn from '@/utils/cn';

interface EyebrowProps {
  children: React.ReactNode;
  className?: string;
  tag?: 'div' | 'h3';
}

// The small uppercase section label used throughout the dialog body.
const Eyebrow = ({ children, className, tag: Tag = 'div' }: EyebrowProps) => (
  <Tag
    className={cn(
      'tw-m-0 tw-mb-2 tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wider tw-text-spa-tertiary',
      className,
    )}
  >
    {children}
  </Tag>
);

export default Eyebrow;
